import { createContext, useContext } from 'react';

export const GuideContext = createContext(false);
export const useGuideEnabled = () => useContext(GuideContext);
